/**
 * 🗑️ DELETE CONTAINER MODAL
 * 
 * Minimalistisches Modal für Container-Deletion
 * - Portal Rendering (über allem)
 * - Backdrop/Overlay für besseren Fokus
 * - Gleicher Style wie delete_modal
 */

import React from 'react';
import ReactDOM from 'react-dom';
import './DeleteContainerModal.css';

const DeleteContainerModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <>
      {/* Backdrop/Overlay */}
      <div 
        className="delete-container-modal-backdrop" 
        onClick={onClose}
      />
      
      {/* Modal Content */}
      <div className="delete_modal delete-container-modal">
        <div className="delete-modal-icon">
          <i className="fas fa-exclamation-triangle"></i>
        </div>
        <h3>Delete Container Section?</h3>
        <p>Are you sure you want to delete this container? All content inside will be permanently removed.</p>
        <div className="delete-modal-buttons">
          <button className="delete-modal-btn delete-modal-btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="delete-modal-btn delete-modal-btn-confirm" onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </>,
    document.body
  );
};

export default DeleteContainerModal;

